import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenantStore } from '../../stores/tenant';
import { useUIStore } from '../../stores/ui';
import styles from './Topbar.module.css';
import type { Tenant } from '../../types';

interface TopbarProps {
  tenants: Tenant[];
}

export function Topbar({ tenants }: TopbarProps) {
  const { selectedTenantId, setSelectedTenant } = useTenantStore();
  const { toggleAIPanel, aiPanelOpen, toggleTheme, theme } = useUIStore();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const selectedTenant = tenants.find(t => t.id === selectedTenantId);

  return (
    <header className={styles.topbar}>
      <div className={styles.left}>
        <div className={styles.tenantSelector}>
          <span className={styles.tenantLabel}>Tenant:</span>
          <select
            className={styles.tenantSelect}
            value={selectedTenantId ?? ''}
            onChange={e => setSelectedTenant(e.target.value || null)}
          >
            <option value="">All Tenants</option>
            {tenants.map(t => (
              <option key={t.id} value={t.id}>{t.display_name}</option>
            ))}
          </select>
          {selectedTenant && (
            <span className={styles.tenantDomain}>{selectedTenant.default_domain ?? ''}</span>
          )}
        </div>
      </div>

      <div className={styles.center}>
        <div className={styles.searchWrapper}>
          <span className={styles.searchIcon}>🔍</span>
          <input
            type="search"
            placeholder="Search tenants, users, devices…"
            className={styles.search}
            value={search}
            onChange={e => setSearch(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter' && search.trim()) {
                navigate(`/search?q=${encodeURIComponent(search.trim())}`);
                setSearch('');
              }
            }}
          />
          <kbd className={styles.shortcut}>/</kbd>
        </div>
      </div>

      <div className={styles.right}>
        <button
          className={[styles.iconBtn, aiPanelOpen ? styles.iconBtnActive : ''].join(' ')}
          onClick={toggleAIPanel}
          title="AI Assistant"
        >
          ✨
        </button>
        <button
          className={styles.iconBtn}
          onClick={toggleTheme}
          title={theme === 'dark' ? 'Light mode' : 'Dark mode'}
        >
          {theme === 'dark' ? '☀️' : '🌙'}
        </button>
        <button className={styles.iconBtn} title="Notifications">
          🔔
        </button>
        <div className={styles.avatar} title="Account">
          U
        </div>
      </div>
    </header>
  );
}
